import React from 'react'
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import PermissionsService from '../auth/PermissionsService'
import { CommissionDefault } from './CommissionDefault'

const CommissionDefaultPage: React.FC = () => {
  const perms = PermissionsService.getPermissions() || {}
  const { hasManageDefaultCommissions } = perms as any

  const crumbs: PageLink[] = [
    { title: 'Configuración', path: '/settings', isSeparator: false, isActive: false },
    { title: 'Comisión por defecto', path: '', isSeparator: true, isActive: true },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        {/* {hasManageDefaultCommissions ? ( */}
          <Route
            path='commission-default'
            element={
              <>
                <CommissionDefault />
                <PageTitle breadcrumbs={crumbs}>Comisión por defecto</PageTitle>
              </>
            }
          />
        {/* ) : (
          <Route path='commission-default' element={<Navigate to='/error/403' replace />} />
        )} */}
      </Route>
      <Route index element={<Navigate to='commission-default' replace />} />
    </Routes>
  )
}

export default CommissionDefaultPage
